module.exports = __webpack_public_path__ + "static/media/pres24.cebb06bd.png";